var Component = require("!../node_modules/_vue-loader@10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=script&index=0!./StoreApp.vue"),
  /* template */
  require("!!../node_modules/_vue-loader@10.3.0@vue-loader/lib/template-compiler?id=data-v-4b15dc0a!../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=template&index=0!./StoreApp.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/StoreApp.vue
// module id = 200
// module chunks = 2